import { Box, Container, Divider, SimpleGrid } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import Header from './Header';
import CollapseItem from '../../common/collapse-item';

const Desktop: React.FC = () => {
  const [showTopCollapse, setShowTopCollapse] = useState<boolean>(true);
  const [showMiddleCollapse, setShowMiddleCollapse] = useState<boolean>(false);
  const [showBottomCollapse, setShowBottomCollapse] = useState<boolean>(false);

  const onClickFirst = () => {
    if (showTopCollapse) {
      setShowTopCollapse(!showTopCollapse);
      setTimeout(() => {
        setShowMiddleCollapse(!showBottomCollapse);
      }, 300);
    } else {
      setShowMiddleCollapse(false);
      setShowBottomCollapse(false);
      setTimeout(() => {
        setShowTopCollapse(true);
      }, 300);
    }
  };

  const onClickSecond = () => {
    if (showMiddleCollapse) {
      setShowMiddleCollapse(!showMiddleCollapse);
      setTimeout(() => {
        setShowBottomCollapse(!showBottomCollapse);
      }, 300);
    } else {
      setShowTopCollapse(false);
      setShowBottomCollapse(false);
      setTimeout(() => {
        setShowMiddleCollapse(true);
      }, 300);
    }
  };

  const onClickThird = () => {
    if (showBottomCollapse) {
      setShowBottomCollapse(!showBottomCollapse);
      setTimeout(() => {
        setShowTopCollapse(!showTopCollapse);
      }, 300);
    } else {
      setShowMiddleCollapse(false);
      setShowTopCollapse(false);
      setTimeout(() => {
        setShowBottomCollapse(true);
      }, 300);
    }
  };

  return (
    <SimpleGrid
      d={{ base: 'none', desktop: 'grid' }}
      columns={2}
      alignItems="center"
      spacing="83px"
      h="560px"
    >
      <Container maxW="xl">
        <Box shadow="distance400" d={showTopCollapse ? 'flex' : 'none'}>
          <StaticImage
            placeholder="blurred"
            alt="before"
            src="../../../assets/images/rendering_personalized_1.jpg"
          />
        </Box>
        <Box shadow="distance400" d={showMiddleCollapse ? 'flex' : 'none'}>
          <StaticImage
            placeholder="blurred"
            alt="before"
            src="../../../assets/images/rendering_personalized_2.jpg"
          />
        </Box>
        <Box shadow="distance400" d={showBottomCollapse ? 'flex' : 'none'}>
          <StaticImage
            placeholder="blurred"
            alt="rendering"
            src="../../../assets/images/rendering_personalized_3.jpg"
          />
        </Box>
      </Container>
      <Container maxW="xl" h="100%">
        <Header mb={{ base: 600, tablet: 800 }} />
        <Box flexDir="column">
          <CollapseItem
            onClick={onClickFirst}
            isActive={showTopCollapse}
            content="This weathered Northeastern home was ready for a complete refresh."
            title="Before"
          />
          <CollapseItem
            onClick={onClickSecond}
            isActive={showMiddleCollapse}
            content="With HOVER, it was easy to visualize and sell premium architectural details that increased the project scope by thousands of dollars."
            title="Rendering"
          />
          <CollapseItem
            onClick={onClickThird}
            isActive={showBottomCollapse}
            content="The result is a beautiful home transformation that delivered on the homeowner's vision."
            title="After"
          />
        </Box>
        <Divider color="neutral.300" mt={showBottomCollapse ? 0 : 500} my={0} />
      </Container>
    </SimpleGrid>
  );
};

export default Desktop;
